import React, { forwardRef } from 'react'

import cn from 'classnames'

import { Spinner } from 'components/Spinner'
import ScreenReaderOnlyText from 'helpers/ScreenReaderOnlyText'

import { ButtonProps } from './types'

const BaseButton: React.FC<ButtonProps> = forwardRef(
  (
    {
      children,
      className,
      isLoading = false,
      type = 'button',
      borderRadius = 'normal',
      animationMode = 'none',
      isIconOnly,
      iconPosition = 'start',
      iconElement,
      hasFullWidth,
      isDisabled,
      isSelected,
      styles,
      testId,
      ...props
    },
    ref,
  ) => {
    const ChildrenWrapper = isIconOnly ? ScreenReaderOnlyText : React.Fragment

    return (
      <button
        ref={ref}
        className={cn(
          styles.base,
          (isDisabled || isLoading) && styles.disabled,
          isSelected && styles.selected,
          hasFullWidth && styles.fullWidth,
          iconElement && styles[`iconPosition-${iconPosition}`],
          styles[`borderRadius-${borderRadius}`],
          styles[`animation-${animationMode}`],
          className,
        )}
        disabled={isDisabled || isLoading}
        // eslint-disable-next-line react/button-has-type
        type={type}
        data-testid={testId}
        {...props}
      >
        {iconElement && (
          <span
            className={cn(styles.iconWrapper, !isIconOnly && styles[`iconWrapper_${iconPosition}`])}
          >
            {iconElement}
          </span>
        )}
        <ChildrenWrapper>{children}</ChildrenWrapper>
        <Spinner isRendered={isLoading} className={styles.spinnerWrapper} />
      </button>
    )
  },
)

export default BaseButton
